<app-update-fullscreen></app-update-fullscreen>
<app-loading></app-loading>
<router-outlet />
@if (
(isAuthenticated$ | async) &&
this.sessionService.settings() &&
this.sessionService.params()['profileId']
) {
<div class="ft-navbar mt-auto mt-lg-0 me-lg-auto">
  <div class="ft-logo d-none d-lg-block"></div>
  @for (item of menuItems(); track $index) {
  @switch (item.type) {
  @case ('external') {
  <a [href]="item.href" target="_system" [class]="item.class" mat-button>
    <div class="ft-item">
      <ft-icon [name]="item.icon" collection="icons" />
      <div class="ft-item__label">{{ item.label }}</div>
    </div>
  </a>
  }
  @default {
  <button [routerLink]="item.url" routerLinkActive="ft-active" [class]="item.class" type="button" mat-button>
    <div class="ft-item">
      <ft-icon [name]="item.icon" collection="icons" />
      <div class="ft-item__label">{{ item.label }}</div>
    </div>
  </button>
  }
  }
  @if ($index === 1) {
  <button type="button" class="ft-fab d-lg-none" mat-icon-button i18n-title title="Open actions"
    (click)="openActions()">
    <ft-icon name="plus" class="ft-icon--2" />
  </button>
  }
  }
  <button type="button" mat-button class="d-block d-lg-none" (click)="openOptions()">
    <div class="ft-item">
      <ft-icon name="ellipsis" collection="icons" />
      <div class="ft-item__label" i18n>More</div>
    </div>
  </button>
  <!-- <button type="button" mat-button class="d-none d-lg-block mt-auto" (click)="sessionService.logout()">
    <div class="ft-item">
      <ft-icon name="sign-out" collection="icons" />
      <div class="ft-item__label" i18n>Sign out</div>
    </div>
  </button> -->
</div>
}
<ng-template #actionsTemplate>
  <div class="ft-list ft-list--menu mt-md-2" style="margin-inline: -1rem">
    <button type="button" isGranted="btn-simulate-credit" class="ft-list__item ft-pie-3" matRipple
      (click)="openForm('simulation')">
      <div class="ft-item">
        <div>
          <div class="ft-item__label" style="font-weight: 500" i18n>
            Simulate credit
          </div>
          <small class="ft-item__note">
            {{ simulateCreditButtonTitle() }}
          </small>
        </div>
      </div>
    </button>
    <button type="button" isGranted="btn-register-credit" class="ft-list__item ft-pie-3" matRipple
      (click)="openForm('credit')">
      <div class="ft-item">
        <div>
          <div class="ft-item__label" style="font-weight: 500" i18n>
            Register credit
          </div>
          <small class="ft-item__note" i18n>
            If you already have an existing credit, register it here.
          </small>
        </div>
      </div>
    </button>
    <button type="button" isGranted="btn-create-beneficiary" class="ft-list__item ft-pie-3" matRipple
      (click)="openForm('beneficiary')">
      <div class="ft-item">
        <div>
          <div class="ft-item__label" style="font-weight: 500" i18n>
            Add beneficiary
          </div>
          <small class="ft-item__note" i18n>
            Add or edit the person who will receive the loan and configure their
            notification preferences.
          </small>
        </div>
      </div>
    </button>
    @if (sessionService.isGranted('MPRM06')) {
    <button type="button" isGranted="btn-add-group" class="ft-list__item ft-pie-3" matRipple
      (click)="openForm('group')">
      <div class="ft-item">
        <div>
          <div class="ft-item__label" style="font-weight: 500" i18n>
            Add group
          </div>
          <small class="ft-item__note" i18n>
            Define groups to organize your credits and keep them sorted.
          </small>
        </div>
      </div>
    </button>
    }
  </div>
</ng-template>

<ng-template #optionsTemplate>
  <div class="ft-list ft-list--menu mt-md-2" style="margin-inline: -1rem">
    <div class="ft-list__item ft-btn-profile justify-content-between">
      <div class="d-flex align-items-center gap-1">
        <ft-icon name="user-profile" collection="icons" />
        <div class="d-flex flex-column">
          <small class="text-muted">{{ sessionService.settings()?.email }}</small>
          <small class="font-size: 13.33px">{{ profile()?.description }}</small>
        </div>
      </div>

      @if ((sessionService.settings()?.profiles?.length || 0) > 1) {
      <button matButton class="ft-item__label" type="button" (click)="openChangeProfile()">
        <div class="ft-item gap-1">
          <small class="ft-item__label" i18n>Change Role</small>
          <ft-icon name="toggle" collection="factoricons-slim" />
        </div>
      </button>
      }

    </div>
    <hr />
    @for (item of menuItems().slice(3); track $index) {
    @switch (item.type) {
    @case ('external') {
    <a [href]="item.href" target="_system" [class]="'ft-list__item ft-pie-3 ' + item.class" matRipple>
      <div class="ft-item">
        <ft-icon [name]="item.icon" collection="icons" />
        <div class="ft-item__label">{{ item.label }}</div>
      </div>
    </a>
    }
    @default {
    <button [routerLink]="item.url" routerLinkActive="ft-active" [class]="'ft-list__item ft-pie-3 ' + item.class"
      type="button" matRipple>
      <div class="ft-item">
        <ft-icon [name]="item.icon" collection="icons" />
        <div class="ft-item__label">{{ item.label }}</div>
      </div>
    </button>
    }
    }
    }
    <hr />
    <button type="button" matRipple class="ft-list__item ft-pie-3" (click)="sessionService.logout()">
      <div class="ft-item">
        <ft-icon name="sign-out" collection="icons" />
        <div class="ft-item__label" i18n>Sign out</div>
      </div>
    </button>
  </div>
</ng-template>

<ng-template #profilesTemplate>
  <div class="ft-list">
    @for (profile of sessionService.settings()?.profiles; track profile.id) {
    <button type="button" matRipple class="ft-list__item text-start"
      [disabled]="profile.id === sessionService.params()['profileId']" (click)="changeProfile(profile.id)">
      <div class="ft-item">
        <div class="flex-grow-1">{{ profile?.description }}</div>
        @if (profile.id === sessionService.params()['profileId']) {
        <ft-icon name="check" />
        }
      </div>
    </button>
    }
  </div>
</ng-template>
